import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Instagram, Mail, Clock } from 'lucide-react';
import { siteData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--brand-dark)] text-white">
      <div className="container-max px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-[var(--brand-primary)]">
              Déclic
            </h3>
            <p className="text-gray-300 mb-4">
              {siteData.business.description}
            </p>
            <div className="flex items-center space-x-2 text-yellow-400">
              <span className="text-xl">⭐</span>
              <span className="font-semibold">
                {siteData.business.rating}/5 ({siteData.business.reviewCount} avis)
              </span>
            </div>
            {siteData.business.lgbtqFriendly && (
              <p className="mt-3 text-sm text-gray-300">
                🏳️‍🌈 LGBTQ+ friendly
              </p>
            )}
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/coaching" className="text-gray-300 hover:text-white transition-colors">
                  Coaching
                </Link>
              </li>
              <li>
                <Link to="/nutrition" className="text-gray-300 hover:text-white transition-colors">
                  Nutrition
                </Link>
              </li>
              <li>
                <Link to="/avis" className="text-gray-300 hover:text-white transition-colors">
                  Avis clients
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-gray-300 hover:text-white transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={20} className="mt-1 flex-shrink-0" />
                <span className="text-gray-300">
                  {siteData.business.address}<br />
                  {siteData.business.city}
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={20} className="flex-shrink-0" />
                <a
                  href={`tel:${siteData.business.phone.replace(/\s/g, '')}`}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {siteData.business.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={20} className="flex-shrink-0" />
                <a
                  href={`mailto:${siteData.business.email}`}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {siteData.business.email}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Clock size={20} className="flex-shrink-0" />
                <span className="text-gray-300">{siteData.business.hours}</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Suivez-nous</h4>
            <a
              href={siteData.business.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
            >
              <Instagram size={24} />
              <span>@declic.coaching</span>
            </a>
            <div className="mt-6">
              <Link
                to="/contact"
                className="btn-primary inline-block"
              >
                Prendre rendez-vous
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Déclic. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/mentions-legales" className="text-gray-400 hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/confidentialite" className="text-gray-400 hover:text-white transition-colors">
                Confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
